/**
 *
 *
 */

export default {
	calendar: {
		defaultView: "month",
		timeslots: 4,
	},
	supportedLanguages: [
		{
			code: "EN",
			title: "Switch To English"
		},
    //{
    //	code: "FR",
    //	title: "français"
    //},
		{
			code: "CN",
			title: "切换简体中文"
		},
		// {
		// 	code: "CN_T",
		// 	title: "繁體中文"
		// },
    //{
    //	code: "KR",
    //	title: "한국어로 변환"
    //}
	],
	APIAddress: "/proxy",
	WAPIAddress: '/proxy-wapi'

}



// WEBPACK FOOTER //
// ./src/constants/config.js